export function isValidPatentStatusArray(array: string[]): array is ("Application" | "Granted")[] {
  const validStatuses = new Set(["Application", "Granted"]);
  return array.every((status) => validStatuses.has(status));
}
